import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { joinPaths } from '~/lib/utils/url_utility';
import FrameworkBadge from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/compliance_dashboard/components/shared/framework_badge.vue?vue3';
import projectsComplianceFrameworks from '../graphql/project_compliance_frameworks.query.graphql';
export default {
    name: 'ComplianceInfo',
    components: {
        FrameworkBadge
    },
    props: {
        projectPath: {
            type: String,
            required: true
        },
        complianceCenterPath: {
            type: String,
            required: true
        },
        canViewDashboard: {
            type: Boolean,
            required: true
        }
    },
    apollo: {
        // eslint-disable-next-line @gitlab/vue-no-undef-apollo-properties
        project: {
            query: projectsComplianceFrameworks,
            variables () {
                return {
                    fullPath: this.projectPath
                };
            },
            update (data) {
                this.complianceFrameworks = data?.project?.complianceFrameworks?.nodes || [];
            },
            error (error) {
                Sentry.captureException(error);
            }
        }
    },
    data () {
        return {
            complianceFrameworks: []
        };
    },
    computed: {
        hasComplianceFrameworks () {
            return this.complianceFrameworks.length > 0;
        }
    },
    methods: {
        getViewDetailsUrl (frameworkId) {
            return joinPaths(gon.gitlab_url, `${this.complianceCenterPath}?id=${getIdFromGraphQLId(frameworkId)}`);
        }
    }
};
